import { reducerWithInitialState } from "typescript-fsa-reducers";
import { State } from "./report.types";
import * as actions from "./report.actions";

export const initialState: Readonly<State> = {
  isReportLoading: false,
  reportSuccess: undefined,
  reportList: [],
  isDownloadReportLoading: false,
};

export default reducerWithInitialState(initialState)
  .case(actions.resetReport, () => ({ ...initialState }))
  .case(actions.isReportLoading, (state, { isReportLoading }) => ({
    ...state,
    isReportLoading,
  }))
  .case(
    actions.isDownloadReportLoading,
    (state, { isDownloadReportLoading }) => ({
      ...state,
      isDownloadReportLoading,
    })
  )
  .case(actions.reportSuccess, (state, { reportSuccess }) => ({
    ...state,
    reportSuccess,
  }))
  .case(actions.reportList, (state, { reportList }) => ({
    ...state,
    reportList,
  }))
  .build();
